export const MAX_VIDEO_BYTES = 500_000_000;
export const CHUNK_BYTES = 10_000_000;
export type Creator = {
  creator_avatar_url: string;
  creator_username: string;
  creator_nickname: string;
  privacy_level_options: string[];
  comment_disabled: boolean;
  duet_disabled: boolean;
  stitch_disabled: boolean;
  max_video_post_duration_sec: number;
};
export function chunkPlan(size: number) {
  if (!Number.isSafeInteger(size) || size < 1 || size > MAX_VIDEO_BYTES)
    throw new Error("Choose a video smaller than 500 MB.");
  const chunkSize = Math.min(size, CHUNK_BYTES);
  return { chunkSize, count: Math.max(1, Math.floor(size / chunkSize)) };
}
export function validatePost(input: any, creator: Creator, approved: boolean) {
  const plan = chunkPlan(input.size);
  if (input.consent !== true)
    throw new Error("Confirm your consent before publishing.");
  if (typeof input.title !== "string" || input.title.length > 2200)
    throw new Error("Caption must be 2,200 characters or fewer.");
  if (
    !Number.isFinite(input.duration) ||
    input.duration <= 0 ||
    input.duration > creator.max_video_post_duration_sec
  )
    throw new Error(
      `This account allows videos up to ${creator.max_video_post_duration_sec} seconds.`,
    );
  if (!creator.privacy_level_options.includes(input.privacy))
    throw new Error("Choose an available visibility option.");
  if (!approved && input.privacy !== "SELF_ONLY")
    throw new Error(
      "Public posting is awaiting TikTok approval. Only private testing is available.",
    );
  if (input.commercial && !input.ownBrand && !input.branded)
    throw new Error("Select your brand, branded content, or both.");
  if (input.commercial && input.branded && input.privacy === "SELF_ONLY")
    throw new Error("Branded content visibility cannot be set to private.");
  return {
    plan,
    postInfo: {
      title: input.title,
      privacy_level: input.privacy,
      disable_comment: creator.comment_disabled || input.comments !== true,
      disable_duet: creator.duet_disabled || input.duet !== true,
      disable_stitch: creator.stitch_disabled || input.stitch !== true,
      brand_organic_toggle:
        input.commercial === true && input.ownBrand === true,
      brand_content_toggle: input.commercial === true && input.branded === true,
      is_aigc: input.aiGenerated === true,
    },
  };
}
